<template>
  <Modal class="my-modal" v-model="visible" title="服务信息" :transfer="false" :mask-closable="false" :closable="false" width="900">
    <Form ref="myForm" :model="formData" :label-width="80" class="page-form">
      <FormItem label="服务类型" class="full">
        {{ formData.name }}
      </FormItem>
      <FormItem label="描述" class="full">
        <div v-html="formData.content"></div>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" @click="visible = false">关闭</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      formData: {},
      loading: false
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {
    async open(data) {
      this.getDetail(data);
      this.visible = true;
    },
    getDetail(data) {
      this.$http({
        url: '/buz/extSvc/cate/detail',
        type: 'GET',
        data: {
          code: data.svcCateCode
        }
      }).then(res => {
        this.formData = res.data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>






